module.exports = __webpack_public_path__ + "img/4.85e8e846.jpg";